(function () {
  'use strict';

  var formatter = new Intl.NumberFormat(document.documentElement.lang || 'en');

  function render(root) {
    var badge = root.querySelector('.jdgm-prev-badge');
    if (!badge) return false;

    var rating = Number.parseFloat(badge.dataset.averageRating || badge.dataset.score || '');
    var count = Number.parseInt(badge.dataset.numberOfReviews || '', 10);
    if (!Number.isFinite(rating) || !Number.isFinite(count) || rating <= 0 || count <= 0) {
      root.hidden = true;
      return false;
    }

    var ratingOutput = root.querySelector('[data-winks-review-rating]');
    var starsOutput = root.querySelector('[data-winks-review-stars]');
    var countOutput = root.querySelector('[data-winks-review-count]');
    if (starsOutput) {
      var boundedRating = Math.min(5, Math.max(0, rating));
      starsOutput.style.setProperty('--winks-review-star-fill', (boundedRating / 5 * 100) + '%');
      starsOutput.setAttribute('aria-label', rating.toFixed(1) + ' out of 5 stars');
    }
    if (ratingOutput) ratingOutput.textContent = rating.toFixed(1);
    if (countOutput) countOutput.textContent = formatter.format(count) + (count === 1 ? ' review' : ' reviews');
    root.hidden = false;
    return true;
  }

  function initialize(root) {
    if (root.dataset.winksReviewProofReady === 'true') return;
    root.dataset.winksReviewProofReady = 'true';
    if (render(root)) return;

    var observer = new MutationObserver(function () {
      if (!render(root)) return;
      observer.disconnect();
      delete root.winksReviewProofObserver;
    });
    root.winksReviewProofObserver = observer;
    observer.observe(root, { childList: true, subtree: true, attributes: true });
  }

  function scan(scope) {
    if (scope instanceof Element && scope.matches('[data-winks-review-proof]')) initialize(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-winks-review-proof]').forEach(initialize);
  }

  function start() {
    scan(document);
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-winks-review-proof]').forEach(function (root) {
        if (root.winksReviewProofObserver) root.winksReviewProofObserver.disconnect();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
